// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"024efde2","455":"66669b37","946":"ec1f4bc9"}[chunkId] + ".chunk.js";
};